import { combineEpics } from 'redux-observable';
// ---- external imports ----

import checkInstantLevelUpEpic from './checkInstantLevelUpEpic';
import missionHandlerEpic from './missionHandlerEpic';
import saveMissionsProgressEpic from './saveMissionsProgressEpic';
import checkInstantLevelFailEpic from './checkInstantLevelFailEpic';
import onLoadedNextLevel from './onLoadedNextLevel';
// ---- local imports ----


export default combineEpics(
	onLoadedNextLevel,
	checkInstantLevelUpEpic,
	checkInstantLevelFailEpic,
	missionHandlerEpic,
	saveMissionsProgressEpic,
);
